module.exports = __webpack_public_path__ + "static/media/blue_blue_white.15f1524c.svg";